import { render, staticRenderFns } from "./MyDrafts.vue?vue&type=template&id=0bdef68c&scoped=true&"
import script from "./MyDrafts.vue?vue&type=script&lang=js&"
export * from "./MyDrafts.vue?vue&type=script&lang=js&"
import style0 from "./MyDrafts.vue?vue&type=style&index=0&id=0bdef68c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bdef68c",
  null
  
)

export default component.exports